<template>
  <div
    :class="theme === 'dark' ? 'bg-secondary-light shadow-dark-900/5 border-dark-800/10 border' : 'bg-dark-50 shadow-white/5'"
    class="p-6 shadow-md animate-fade-in rounded-3xl"
  >
    <blockquote :class="theme === 'dark' ? 'text-dark-50' : 'text-dark-900'">
      <!-- Stars -->
      <div class="flex">
        <svg
          v-for="ratingItem in [0, 1, 2, 3, 4]"
          :key="ratingItem"
          viewBox="0 0 20 20"
          aria-hidden="true"
          class="w-5 h-5"
          :class="[rating.score > ratingItem ? 'fill-primary' : 'fill-dark-300']"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      </div>
      <!-- description -->
      <div
        class="mt-4 leading-6 cursor-pointer"
        :class="open ? 'line-clamp-none' : 'line-clamp-5'"
        @click="open = !open"
        v-html="rating.description"
      />
      <!-- User -->
      <p
        :class="theme === 'dark' ? 'text-dark-200' : 'text-dark-700'"
        class="mt-3 text-sm leading-7"
      >
        {{ rating.user_nickname }}
      </p>
    </blockquote>
  </div>
</template>

<script setup lang="ts">
defineProps({
  rating: {
    type: Object,
    default: null,
  },
  theme: {
    type: String,
    default: 'dark',
  },
})

const open = ref(false)
</script>
